var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.69 99.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.2;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3.-Upgrade-_-Payment-_",
    "data-name": "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-2:-Secure"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lock"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "cls-2",
    points: "0 0 99.69 0 99.69 99.69 0 99.69 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M75.08,33.27H70.92V25a20.77,20.77,0,0,0-41.54,0v8.31H25.23a8.31,8.31,0,0,0-8.31,8.31V83.12a8.31,8.31,0,0,0,8.31,8.31H75.08a8.3,8.3,0,0,0,8.3-8.31V41.58A8.3,8.3,0,0,0,75.08,33.27Zm-12,0H37.28V25A12.88,12.88,0,0,1,63,25v8.31Z",
    transform: "translate(-0.31 -0.04)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.de9c3f3f9f3cc502cf58ae788228ae29.svg";
export { ForwardRef as ReactComponent };